/** @var { SunModelState } */
const STATE = {
  sunModel: {
    removeItemsModal: {
      show: false,
      loading: false,
      title: null,
      items: [],
      fields: [],
      callback: null,
    },
    confirmModal: {
      show: false,
      title: null,
      text: null,
      yesText: null,
      okVariant: null,
      noText: null,
      callback: null,
    },
    optionsFilter: {
      displayMeasures: false,
      displayAttributes: false,
      displayMinorElements: false,
      darkMode: false,
      filteredFacts: null,
      filteredDimensions: null,
    },
    loaded: false,
    loading: false,
    data: {
      facts: [],
      dimensions: [],
      links: [],
    },
    nodeTypes: {
      dimension: 'dimension',
      fact: 'fact',
      attribute: 'attribute',
    },
    originalData: {
      facts: [],
      dimensions: [],
      links: [],
    },
  },
  factModal: {
    loading: false,
    show: false,
    data: {},
    defaultData: {
      entityDisplayName: '',
      description: '',
      tags: [],
      isOnPhysicalModel: true,
      isOnLogicalModel: true,
    },
  },
  measuresModal: {
    loading: false,
    show: false,
    factName: null,
    data: {
      uuid: null,
      name: null,
      notes: null,
      tags: null,
      minorElement: false,
      includeOnPhysicalModel: true,
      includeOnLogicalModel: true,
      dataType: null,
      numericPrecision: null,
      scalePrecision: null,
      defaultValue: null,
      aggregationType: null,
    },
  },
  attributesModal: {
    loading: false,
    show: false,
    entityId: '',
    entityType: '',
    aggregationTypes: [],
    dataTypes: [],
    data: {},
    defaultData: {
      attributeDisplayName: '',
      description: '',
      tags: [],
      exampleValues: '',
      reportingChangeType: 'type1',
      minorElement: false,
      isOnPhysicalModel: true,
      isOnLogicalModel: true,
      dataType: null,
      aggregationType: null,
      numericPrecision: 16,
      numericScale: 8,
      characterLength: 255,
      defaultValue: null,
    },
  },
  dimensionModal: {
    loading: false,
    show: false,
    factName: null,
    data: {},
    defaultData: {
      entityDisplayName: '',
      description: '',
      tags: [],
      isOnPhysicalModel: true,
      isOnLogicalModel: true,
    },
  },
  linkModal: {
    loading: false,
    show: false,
    data: {
      fromEntityId: '',
      toEntityId: '',
      alias: '',
    },
  },
  optionsModal: {
    show: false,
  },
  sliderModal: {
    show: false,
    data: {},
  },
  tagsModal: {
    show: false,
    data: {},
    defaultData: {
      tags: [],
      dimensions: [],
      factValues: [],
    },
  },
  tags: {
    loading: false,
    data: [],
  },
};

export default STATE;
